import { ClassesBuilder } from '@utilities';

const classesConfig = {
  span: 'leading-none h-[1em] w-[1em] transition hover:scale-105',
  icon: 'inline-block',
};

export default new ClassesBuilder(classesConfig);
